import { MatSnackBar } from '@angular/material/snack-bar';
import { PointOfInterest, Itinerary } from './../itineray.model';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ItinerarySnapshot } from './../itinerary-snapshot.model';
import { ItinerarySnapshotServiceFactory } from './../itinerary-snapshot.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-snapshots',
  templateUrl: './itinerary-snapshots.component.html',
  styleUrls: ['./itinerary-snapshots.component.css']
})
export class ItinerarySnapshotsComponent implements OnInit {

  limit = 10;
  itinerary: Itinerary;
  itinerarySnapshots$: Observable<ItinerarySnapshot[]>;

  constructor(private itinerarySnapshotServiceFactory: ItinerarySnapshotServiceFactory, private route: ActivatedRoute, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.itinerary = this.route.snapshot.parent.data.itinerary;
    this.list(this.limit);
  }

  getNotGeneratedPois(pois: PointOfInterest[]) {
    return pois.filter((poi) => !poi.generated);
  }

  restore(snapshot: ItinerarySnapshot) {
    if (confirm("Sei veramente sicuro di voler ripristinare questa versione dell'itinerario?")) {
      Object.assign(this.route.snapshot.parent.data.itinerary, snapshot.itinerary);
      this.snackBar.open(
        "La versione è stata ripristinata. Controlla l'itinerario e fai click su SALVA per confermare.",
        null,
        {
          duration: 4000
        }
      );
    }
  }

  list(limit: number) {
    this.itinerarySnapshots$ = this.itinerarySnapshotServiceFactory.create(this.itinerary.id).list(ref => ref.orderBy("timestamp", "desc").limit(this.limit));
  }

}
